import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
  imports: [CommonModule]
})
export class SuccessComponent implements OnInit {

  @Input() public showForm: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
